import { serviceRequest } from 'utils/http';
import { ChangeCurrentPasswordDto, SiteEmployeeService } from 'common/api';

export function updatePasswordAPI(requestBody: ChangeCurrentPasswordDto) {
  return serviceRequest(() =>
    SiteEmployeeService.siteEmployeeControllerUpdateCurrentPassword(requestBody)
  );
}
